import {
  type SourceMappingBuildContext,
  type SourceMappingOptionGroup,
  type MappingOption,
} from '../types'

export const buildOrganizationalCategoryOptions = (
  context: SourceMappingBuildContext
): SourceMappingOptionGroup | null => {
  const { translatedLabels, isHeaderMemoMappingEnabled } = context

  const options: MappingOption[] = [
    {
      label: translatedLabels.singularPrimaryOrgCategoryLabel,
      value: 'location',
      type: 'native',
      active: true,
    },
    {
      label: translatedLabels.singularSecondaryOrgCategoryLabel,
      value: 'department',
      type: 'native',
      active: true,
    },
    ...(isHeaderMemoMappingEnabled
      ? [
          {
            label: translatedLabels.billNotesLabel,
            value: 'bill_notes',
            type: 'native' as const,
            active: true,
          },
          {
            label: translatedLabels.billNotesAndUrlLabel,
            value: 'bill_notes_and_url',
            type: 'native' as const,
            active: true,
          },
          {
            label: translatedLabels.billUrlLabel,
            value: 'bill_url',
            type: 'native' as const,
            active: true,
          },
        ]
      : []),
  ]

  return {
    options,
  }
}
